import { categories } from '@/mocks/resources';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-stack-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-semibold text-foreground-900 font-heading">
                  老六资源库
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                海量资源一站式获取平台。涵盖学习资料、工具软件、影音素材等优质内容，免费分享，持续更新。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">资源分类</h4>
              <ul className="flex flex-col gap-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/xuexi-ziliao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    最新资源
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h4>
              <p className="text-sm text-foreground-600 mb-3">
                获取最新资源更新通知
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-100 hover:text-primary-600 transition-colors text-foreground-600 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-100 hover:text-primary-600 transition-colors text-foreground-600 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-100 hover:text-primary-600 transition-colors text-foreground-600 cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; {currentYear} 老六资源库 - 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">使用条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}